module.exports = "/assets/dist/images/car.png?5f344e123e830665f547e162780ea69c";